module.exports = __webpack_public_path__ + "img/1.044b8b2b.jpg";